export default {
    "create-document" : 'Create a transfer document',
    "delete-document": 'Delete Document',
    "are-you-sure-you-want-to-delete-the-document": "Are you sure you want to delete the document?",
    "source-warehouse-material": "Source warehouse material",
    "target-warehouse-material": "Target warehouse material",
    "multiple-warehouses": "Multiple warehouses"
}